import React from "react";
import { Card } from "react-bootstrap";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import SpeakerIcons from "../SpeakerIcons";
import { ReactComponent as SpeakerIcon } from "assets/svg/speaker-icon.svg";
import { Link } from "react-router-dom";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

function stripHtml(html) {
  let tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

const GroupSeriesCard = ({ groupSeries }) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  return (
    <Link className="w-100" to={`/group-session/series/${groupSeries.id}`}>
      <Card className="rounded-lg h-100 w-100">
        {isPhonePortrait && groupSeries.number_of_sessions !== 1 && (
          <div
            className={getClasses(
              "rounded-lg",
              styles["session-number-tag--phone"],
            )}
          >
            {groupSeries.number_of_sessions} sessions
          </div>
        )}
        <div
          className={getClasses(
            "d-flex align-items-center",
            !isPhonePortrait &&
              groupSeries.speakers.length !== 1 &&
              "justify-content-between",
            !isPhonePortrait
              ? styles["series-card__header"]
              : styles["series-card__header--phone"],
          )}
        >
          <SpeakerIcons groupSeries={groupSeries} />
          {groupSeries.speakers.length === 1 ? (
            <div
              className={getClasses(
                "ml-3 md-16",
                !isPhonePortrait ? "blue" : "deep-blue",
              )}
            >
              {groupSeries.next_session.orchid_pro_firstname}{" "}
              {groupSeries.next_session.orchid_pro_lastname}
            </div>
          ) : (
            <Card.Text className="gray01 rg-16 ml-3 d-flex align-items-center">
              <SpeakerIcon />
              &nbsp;{groupSeries.speakers.length} speakers
            </Card.Text>
          )}
        </div>

        <div
          className={
            !isPhonePortrait
              ? styles["series-card__body"]
              : styles["series-card__body--phone"]
          }
        >
          {!isPhonePortrait &&
            (groupSeries.number_of_sessions !== 1 ? (
              <div className={styles["session-number-tag"]}>
                {groupSeries.number_of_sessions} sessions series
              </div>
            ) : (
              <div className={styles["session-number-tag"]}>
                One time session
              </div>
            ))}
          <Card.Text
            as="h4"
            className={getClasses(
              "d-inline darker questrial",
              !isPhonePortrait ? "rg-24" : "rg-17",
            )}
          >
            {groupSeries.number_of_sessions === 1
              ? groupSeries.next_session.topic
              : groupSeries.title}
          </Card.Text>
          <div className="rg-14 darker module line-clamp-3">
            {stripHtml(groupSeries.description)}
          </div>
        </div>
      </Card>
    </Link>
  );
};

export default GroupSeriesCard;
